// extracted by mini-css-extract-plugin
export default {"chip-container":"chip_chip-container__9KUPR","close":"chip_close__uv1OM","name":"chip_name__SQDqK"};